import api from '@/api'

export const getBuildingInfo = async id => {
  const urlEnd = `/v2/buildings/openLink/${id}`
  const type = 'get'
  const resp = await api.asyncRequest(urlEnd, type)
  return resp.ok ? resp.data : Promise.reject(resp.data)
}
